module.exports = __webpack_public_path__ + "static/media/PleasantlyPickledlogo2015.0efa7b04.webp";